import { finalRouteApi } from "./CommonApiUrl"


const audioOrderDefaultURL = {
    listApi: `${finalRouteApi}/Audio-HomePage-Order/index`,
    orderApi: `${finalRouteApi}/Audio-HomePage-Order/ordering`,
    editApi: `${finalRouteApi}/Audio-HomePage-Order/edit`,
    updateApi: `${finalRouteApi}/Audio-HomePage-Order/update`,
    editRouteLink: `${finalRouteApi}/Audio_URL`,
    enableSettingURL: `${finalRouteApi}/Web-Audio-HomePage/index`,
    updateSettingURL: `${finalRouteApi}/Web-Audio-HomePage/update`,
}

export { audioOrderDefaultURL }